module.exports = __webpack_public_path__ + "img/ocean-room-4.4234da7e.jpg";